<!-- 文档权限 -->
<template>
  <div>
    <el-table :data="tableData" :show-header="false" :cell-style="cellStyle" border >
      <el-table-column width="160px" fixed >
        <template #default="{ row }">
          <el-checkbox v-model="row.$selectAll" :indeterminate="row.indeterminate" :true-label="1" :false-label="0" @change="selectAll(row)" :title="row.name">{{ row.name }}</el-checkbox>
        </template>
      </el-table-column>
      <el-table-column>
        <!-- roleType  1 设计区  2 提资区  3 成品区  企业级文档权限-->
        <!-- roleType  1630981681702设计区  1630981803194提资区  1630981811371 成品区    项目级文档权限-->
        <!-- 接口不一样 -->
        <template #default="{ row }">
          <el-checkbox v-model="row.$show" :true-label="1" :false-label="0" @change="showDown(row)">可见</el-checkbox>
          <el-checkbox v-model="row.$down" :true-label="1" :false-label="0" @change="downShow(row)">可下载</el-checkbox>
          <el-checkbox v-model="row.fileNew" :true-label="1" :false-label="0" @change="isSelect(row,row.fileNew)" v-if="roleType==='1'">上传</el-checkbox>
          <el-checkbox v-model="row.folderNew" :true-label="1" :false-label="0" @change="isSelect(row,row.folderNew)">新建文件夹</el-checkbox>
          <el-checkbox v-model="row.fileDel" :true-label="1" :false-label="0" @change="isSelect(row,row.fileDel)">删除</el-checkbox>
          <!-- <el-checkbox v-model="row.isSubmit" :true-label="1" :false-label="0" @change="isSelect(row,row.isSubmit)" v-if="roleType==='1'">提资准备</el-checkbox> -->
          <!-- <el-checkbox v-model="row.isPlaceFile" :true-label="1" :false-label="0" @change="isSelect(row,row.isPlaceFile)" v-if="roleType==='1'">归档</el-checkbox> -->
          <!-- <el-checkbox v-model="row.isPrint" :true-label="1" :false-label="0" @change="isSelect(row,row.isPrint)" v-if="roleType==='1'">打印非正式图纸</el-checkbox> -->
          <!-- <el-checkbox v-model="row.isPrint" :true-label="1" :false-label="0" @change="isSelect(row,row.isPrint)" v-if="roleType==='1630981811371'||roleType==='3'">成品打印</el-checkbox> -->
          <!-- <el-checkbox v-model="row.isSnapshot" :true-label="1" :false-label="0" @change="isSelect(row,row.isPriviSet)">设置快照</el-checkbox> -->
          <el-checkbox v-model="row.isPriviSet" :true-label="1" :false-label="0" @change="isSelect(row,row.isPriviSet)">权限分配</el-checkbox>
          <el-checkbox v-model="row.priviAll" :true-label="1" :false-label="0" @change="isSelect(row,row.priviAll)">重命名</el-checkbox>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  export default {
    props:{
      tableData:{ type: Array, required: false },
      roleType:{ type: String, required: false },
      refreshStatus: {
        type: Function
      }
    },
    data(){
      return{ }
    },
    methods:{
      selectAll(row) {
        row.indeterminate = false
        if (row.$selectAll === 1) {
          row.$show = 1;
          row.$down = 1;
          row.fileNew = 1;
          row.folderNew = 1;
          row.fileDel = 1;
          // row.isSubmit = 1;
          row.isPlaceFile = 1;
          // row.isPrint = 1;
          row.isPriviSet = 1;
          row.priviAll = 1;
          // row.isSnapshot = 1
        } else {
          row.$show = 0;
          row.$down = 0;
          row.fileNew = 0;
          row.folderNew = 0;
          row.fileDel = 0;
          // row.isSubmit = 0;
          row.isPlaceFile = 0;
          // row.isPrint = 0;
          row.isPriviSet = 0;
          row.priviAll = 0;
          // row.isSnapshot = 0
        }
        
      },
      afterChanged(row) {
        if (typeof this.refreshStatus === 'function') {
          this.refreshStatus(row)
        }
      },
      // 可见与可下载数据处理
      showDown(row) {
        // let { folderId, $selectAll , isSys , name , priviId , userId,userInfo,userType,isRead,...target} = row;
        if (row.$show === 0) {
          row.$down = 0;row.$selectAll = 0;
        } else if (this.designArea(row)) {
          row.$selectAll = 1;
        }else if(this.carryInfoArea(row)){
          row.$selectAll = 1;
        }else if (this.becomeProductArea(row)) {
          row.$selectAll = 1;
        } 
        this.afterChanged(row)
      },
      downShow(row) {
        if (row.$down === 1 && row.$show === 0) {
          row.$show = 1
          if (this.designArea(row)) {
          row.$selectAll = 1;
          }else if(this.carryInfoArea(row)){
            row.$selectAll = 1;
          }else if (this.becomeProductArea(row)) {
            row.$selectAll = 1;
          }
        } else if (this.designArea(row)) {
          row.$selectAll = 1;
        }else if(this.carryInfoArea(row)){
          row.$selectAll = 1;
        }else if (this.becomeProductArea(row)) {
          row.$selectAll = 1;
        } else {
          row.$selectAll = 0;
        }
        this.afterChanged(row)
      },
      isSelect(row, value) {
        if (value === 0) {
          row.$selectAll = 0
        } else if (this.designArea(row)) {
          row.$selectAll = 1;
        }else if(this.carryInfoArea(row)){
          row.$selectAll = 1;
        }else if (this.becomeProductArea(row)) {
          row.$selectAll = 1;
        }
        this.afterChanged(row)
      },
      //设计区
      designArea(row){
       const ischeck=row.$show === 1 && row.$down === 1 && row.fileNew === 1 && row.folderNew === 1 && row.fileDel === 1 && row.isSubmit === 1 && row.isPlaceFile === 1 && row.isPrint === 1 && row.isPriviSet === 1 && row.priviAll === 1 && row.isSnapshot === 1
       const isdesign=this.roleType == '1630981681702'||this.roleType == '1'
       return ischeck && isdesign
      },
      //设计区
      carryInfoArea(row){
        const ischeck=row.$show === 1 && row.$down === 1  && row.folderNew === 1 && row.fileDel === 1 && row.isPriviSet === 1 && row.priviAll === 1 && row.isSnapshot === 1
        const isdesign=this.roleType == '1630981803194'||this.roleType == '2'
        return ischeck && isdesign
      },
      //设计区
      becomeProductArea(row){
        const ischeck=row.$show === 1 && row.$down === 1 && row.fileNew === 1 && row.folderNew === 1 && row.fileDel === 1 && row.isPrint === 1 && row.isPriviSet === 1 && row.priviAll === 1 && row.isSnapshot === 1
        const isdesign=this.roleType == '1630981811371'||this.roleType == '3'
        return ischeck && isdesign
      },
      cellStyle({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 0) {
          // 指定列号
          return "background: rgba(71, 119, 231, 0.03)";
        }
      }
    }
  }
</script>

<style lang="less" scoped>
</style>
